import React, { useEffect, useState } from "react";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "../ui/navigation-menu";
import { Search, Zap, User, ShoppingCart, BellIcon, ArrowLeftRight } from "lucide-react";
import { SidebarTrigger } from "../ui/sidebar";
import { Link, useNavigate } from "react-router-dom";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "../ui/dropdown-menu";
import { NotificationDropdown, UserDropdown } from "@/components";
import { IconItem } from "@/types/AppTypes";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { Button } from "../ui/button";
import { executeGraphQLMutation } from "@/utils/helper/graphql-helper";
import { updateUserInfo } from "@/graphql/mutations";
import { generateClient } from "@/utils/helper/aws-generateClient-singleton";
import ls from "@/utils/SecureLS";
import { setUser } from "@/store/slices/authSlice";
import SearchDropdown from "../searchDropdown/SearchDropdown";
import { sortProductByName } from "@/utils/helper/sortProductByName";
import capitalizeWords from "@/utils/helper/capitalizeWords";
import { useCartManagement } from "@/hooks/useCartManagement";

const Header: React.FC = () => {
  const { categories, brands,cartItems } = useAppSelector(
    (state) => state.app
  );

  const [cartCount, setCartCount] = useState<number | null>(null);
  const { cartItemCount, isAuthenticated } = useCartManagement();

 
  useEffect(() => {
    if(isAuthenticated){
      setCartCount(cartItemCount);
    }else{
      setCartCount(cartItems?.length);
    }
  }, [cartItemCount, cartItems]);

  const icons: IconItem[] = [
    {
      icon: <Search className="h-4 w-4 group-hover:text-white" />,
      label: "Search",
      hasDropdown: true,
      dropdownContent: <SearchDropdown />,
    },
    {
      icon: <Zap className="h-4 w-4 group-hover:text-white" />,
      label: "Quick Reorder",
      action: "/quick-reorder",
      className: "hidden md:block",
    },
    {
      icon: <BellIcon className="h-4 w-4 group-hover:text-white" />,
      label: "Notifications",
      NotificationCount: 0,
      hasDropdown: true,
      dropdownContent: <NotificationDropdown />,
    },
    {
      icon: <User className="h-4 w-4 group-hover:text-white" />,
      label: "Profile",
      hasDropdown: true,
      dropdownContent: <UserDropdown />,
      className: "hidden md:block",
    },

    {
      icon: <ShoppingCart className="h-4 w-4 group-hover:text-white" />,
      label: "Cart",
      action: "/cart",
      NotificationCount: cartCount ?? 0,
    },
  ];

  return (
    <header className="bg-white border-b border-gray-300  sticky top-0 z-50 flex ">
      <div className="container mx-auto px-4 py-3 ">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2 md:space-x-4">
            {/* sidebar trigger from here */}
            <SidebarTrigger className="md:hidden" />

            <div className="font-bold text-2xl">
              <Link to="/">PALETTE</Link>
            </div>

            <NavigationMenu className="hidden lg:flex pl-8">
              <NavigationMenuList>
                {/* <NavigationMenuItem>
                  <NavigationMenuTrigger>Products</NavigationMenuTrigger>
                  <NavigationMenuContent className="bg-white  ">
                    <ul className="grid w-[400px] gap-1 p-2 md:w-[500px] md:grid-cols-2 lg:w-[600px] bg-white ">
                      {sortProductByName(productsForDisplay)?.slice(0, 10)?.map((product) => (
                        <Link
                          key={product?.name}
                          to={`product/${product?.product_id}`}
                          className={
                            "block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                          }
                        >
                          <div className="text-sm font-medium leading-none">{product?.name}</div>
                          <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                            <span className="text-xs text-palette-text ">
                              {product?.brand?.name} - ${product?.price}
                            </span>
                          </p>
                        </Link>
                      ))}
                    </ul>
                    <Link to="/products">
                      <Button className="w-full ">View All Products</Button>
                    </Link>
                  </NavigationMenuContent>
                </NavigationMenuItem> */}
                <NavigationMenuItem>
                  <NavigationMenuTrigger>Shop By Brand</NavigationMenuTrigger>
                  <NavigationMenuContent className="bg-white NavigationMenuContent">
                    <ul className="grid w-[400px] gap-1 p-2 md:w-[500px] md:grid-cols-2 lg:w-[600px] bg-white ">
                      {brands?.slice(0, 10)?.map((brand) => (
                        <Link
                          key={brand?.name}
                          to={`brand/${brand?.id}`}
                          className={
                            "block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                          }
                        >
                          <div className="text-sm font-medium leading-none">
                            {capitalizeWords(brand?.name || "")}
                          </div>
                          {/* <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                            <span className="text-xs text-palette-text ">
                              {brand?.description?.slice(0, 115)}
                            </span>
                          </p> */}
                        </Link>
                      ))}
                    </ul>
                    <Link to="/brands">
                      <Button className="w-full ">View All Brands</Button>
                    </Link>
                  </NavigationMenuContent>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <NavigationMenuTrigger>Shop By Category</NavigationMenuTrigger>
                  <NavigationMenuContent className="bg-white NavigationMenuContent">
                    <ul className="grid w-[400px] gap-1 p-2 md:w-[500px] md:grid-cols-2 lg:w-[600px] bg-white ">
                      {categories?.slice(0, 10)?.map((category) => (
                        <Link
                          key={category?.name}
                          to={`category/${category?.id}`}
                          className={
                            "block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                          }
                        >
                          <div className="text-sm font-medium leading-none">
                            {capitalizeWords(category?.name || "")}
                          </div>
                          {/* <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                              <span className="text-xs text-palette-text ">
                                {category?.description?.slice(0, 115)}
                              </span>
                            </p> */}
                        </Link>
                      ))}
                    </ul>
                    <Link to="/categories">
                      <Button className="w-full ">View All Categories</Button>
                    </Link>
                  </NavigationMenuContent>
                </NavigationMenuItem>
              </NavigationMenuList>
            </NavigationMenu>
          </div>

          <div className="flex justify-between items-center ">
            <div className="ml-4 md:ml-0 flex items-center md:space-x-4">
              {icons.map((item, index) => (
                <div key={index} className={`relative ${item.className || ""}`}>
                  {item.hasDropdown ? (
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <button
                          className="group p-3 hover:bg-icon-hover rounded-md relative "
                          title={item?.label}
                        >
                          {item?.icon}
                          {(item.NotificationCount ?? 0) > 0 && (
                            <span className="absolute top-0 right-0 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                              {item.NotificationCount}
                            </span>
                          )}
                        </button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent align="end" className=" py-1 bg-white">
                        {item.dropdownContent}
                      </DropdownMenuContent>
                    </DropdownMenu>
                  ) : (
                    <Link to={item.action || "#"}>
                      <button
                        className="group p-3 hover:bg-icon-hover rounded-md relative"
                        title={item.label}
                      >
                        {item.icon}
                        {(item.NotificationCount ?? 0) > 0 && (
                          <span className="absolute top-0 right-0 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                            {item.NotificationCount}
                          </span>
                        )}
                      </button>
                    </Link>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
